import {Component, Input, OnInit} from '@angular/core';
import {ClimatelogDataService} from "../../climatelog/climatelogDataService";
import {QueueDataService} from "../queueDataService";
import {Queuecommandlist} from "../queueData";
import {interval, Subscription} from "rxjs";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.css']
})
export class QueueComponent implements OnInit {
  public loaderStatus: number = 0;
  queuecommandlist: Queuecommandlist[] | undefined;
  private updateSubscription: Subscription | undefined;

  constructor(private queueDataService: QueueDataService) {
  }

  ngOnInit(): void {
    this.UpdateData();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }


  ReSubscribe(): void {
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.queueDataService.GetData().subscribe({
      next: queueRoot => {
        this.queuecommandlist = queueRoot.queuecommandlist;
        this.loaderStatus = 1;
        this.ReSubscribe();
      }
    });

  }


}
